<div class="modal-header pasajeros-header">
  <div>
    <h5 class="modal-title">
      <i class="fa fa-users me-2"></i>
      Gestión de pasajeros
    </h5>

    <small>
      Extracto del contrato #{{ extractoId }}
    </small>
  </div>

  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Cerrar"
    (click)="activeModal.dismiss()">
  </button>
</div>

<div class="modal-body">

  <!-- Resumen -->
  <div class="row g-3 mb-4">
    <div class="col-md-6">
      <div class="resumen-card">
        <div class="resumen-icon">
          <i class="fa fa-users"></i>
        </div>

        <div>
          <small>Pasajeros registrados</small>
          <h4>{{ totalPasajeros }}</h4>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="resumen-card">
        <div class="resumen-icon">
          <i class="fa fa-id-card"></i>
        </div>

        <div>
          <small>Estado de gestión</small>
          <h6>{{ modoEdicion ? 'Editando pasajero' : 'Registro de pasajeros' }}</h6>
        </div>
      </div>
    </div>
  </div>

  <!-- Formulario -->
  <div class="formulario-pasajero mb-4">
    <h6 class="section-title">
      <i class="fa fa-user-plus me-2"></i>
      {{ modoEdicion ? 'Editar pasajero' : 'Agregar pasajero' }}
    </h6>

    <form [formGroup]="pasajeroForm" (ngSubmit)="guardarPasajero()">
      <div class="row g-3">

        <div class="col-md-4">
          <label class="form-label">Tipo de Documento: *</label>

          <select class="form-select" formControlName="tipo_documento">
            <option *ngFor="let tipo of TipoDeDocumento" [value]="tipo.value">
              {{ tipo.label }}
            </option>
          </select>

          <small
            class="text-danger"
            *ngIf="pasajeroForm.get('tipo_documento')?.touched &&
                   pasajeroForm.get('tipo_documento')?.invalid">
            Selecciona el tipo de documento.
          </small>
        </div>

        <div class="col-md-4">
          <label class="form-label">Número de Documento: *</label>

          <input
            type="number"
            class="form-control text-dark"
            formControlName="numero_documento"
            maxlength="30"
            autocomplete="off"
            placeholder="Número de identificación">

          <small
            class="text-danger"
            *ngIf="pasajeroForm.get('numero_documento')?.touched &&
                   pasajeroForm.get('numero_documento')?.invalid">
            Ingresa un número de documento válido.
          </small>
        </div>

        <div class="col-md-4">
          <label class="form-label">Nombre Completo: *</label>

          <input
            type="text"
            class="form-control"
            formControlName="nombresCompleto"
            maxlength="100"
            placeholder="Nombre completo del pasajero">

          <small
            class="text-danger"
            *ngIf="pasajeroForm.get('nombresCompleto')?.touched &&
                   pasajeroForm.get('nombresCompleto')?.invalid">
            Los nombres son obligatorios.
          </small>
        </div>

       
        <div class="col-md-12">
          <label class="form-label">Observación:</label>
          <textarea
            class="form-control"
            formControlName="observacion"
            placeholder="Observación opcional"
            rows="3">
          </textarea> 
          
        </div>

      </div>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <button
          *ngIf="modoEdicion"
          type="button"
          class="btn btn-outline-secondary"
          (click)="cancelarEdicion()">
          Cancelar edición
        </button>

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="guardando">

          <i
            class="fa me-2"
            [ngClass]="modoEdicion ? 'fa fa-save' : 'fa fa-plus'">
          </i>

          {{
            guardando
              ? 'Guardando...'
              : modoEdicion
                ? 'Actualizar pasajero'
                : 'Agregar pasajero'
          }}
        </button>
      </div>
    </form>
  </div>

  <!-- Listado -->
  <div class="listado-header">
    <h6 class="section-title mb-0">
      Pasajeros registrados
    </h6>

    <span class="badge bg-primary">
      {{ totalPasajeros }} pasajeros
    </span>
  </div>

  <div class="table-responsive tabla-pasajeros mt-3">
    <table class="table table-hover align-middle mb-0">
      <thead>
        <tr>
          <th style="width: 55px;">#</th>
          <th>Documento</th>
          <th>Nombre Completo</th>
          <th>Estado</th>
          <th>Observación</th>
          <th class="text-center" style="width: 100px;">Acciones</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="cargando">
          <td colspan="5" class="text-center py-4">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Cargando pasajeros...
          </td>
        </tr>

        <tr *ngIf="!cargando && pasajeros.length === 0">
          <td colspan="5" class="text-center py-5">
            <i class="fa fa-users empty-icon"></i>

            <p class="mb-1 mt-2">No hay pasajeros registrados</p>

            <small class="text-dark">
              Utiliza el formulario para agregar el primero.
            </small>
          </td>
        </tr>

        <tr
          *ngFor="let pasajero of pasajeros; let i = index"
          [class.fila-editando]="pasajero.id === pasajeroId">

          <td>{{ pasajero.id}}</td>

          <td>
            <div class="documento-tipo">
              {{ pasajero.tipo_documento }}
            </div>

            <span>{{ pasajero.numero_documento }}</span>
          </td>

          <td>
            <strong>
              {{ pasajero.nombresCompleto }}
            </strong>
          </td>
          <td>
            <span class="badge" [ngClass]="{
                  'status-activo': pasajero.estado === 'ACTIVO',
                  'status-retirado': pasajero.estado === 'RETIRADO'
                }">
              {{ pasajero.estado }}
            </span>
          </td>
          <td>
            {{ pasajero.observacion || '—' }}
          </td>

          <td>
            <div class="d-flex justify-content-center gap-2">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary btn-rounded"
                title="Editar pasajero"
                (click)="editarPasajero(pasajero)">
                <i class="fa fa-pencil"></i>
              </button>

              <button
                type="button"
                class="btn btn-sm btn-outline-danger btn-rounded"
                title="Retirar pasajero"
                (click)="retirarPasajero(pasajero)">
                <i class="fa fa-trash"></i>
              </button>
             
               <button type="button" *ngIf="pasajero.estado !== 'ACTIVO'"
                                    class="btn btn-sm btn-outline-success btn-rounded" title="Activar Pasajero"
                                    (click)="activarPasajero(pasajero)">
                                    <i class="icofont icofont-check"></i>
                                </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss()">
    Cerrar
  </button>

<button
  type="button"
  class="btn btn-primary"
  (click)="generarListado()"
  [disabled]="!pasajeros || pasajeros.length === 0">

  <i class="fa fa-print me-2" *ngIf="!isCreating"></i>
  <i class="fa fa-save me-1" *ngIf="isCreating"></i>
  {{ isCreating ? 'Guardar' : 'Imprimir listado' }}
</button>
</div>